/**
 * Korean (KRW) tag-focused transaction feed for the tags use case.
 */

/** @type {Array<import('../../mock-tagged-transactions.js').MockTaggedTransaction>} */
export const MOCK_TAGGED_TRANSACTIONS_KO = [
	{
		id: 'tag-1',
		date: '2026-08-02',
		type: 'Purchase',
		amount: 48000,
		description: '업무 점심',
		accountId: 'acc-credit',
		accountName: '리워드 카드',
		currency: 'KRW',
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		tagNames: '업무, 세금',
	},
	{
		id: 'tag-2',
		date: '2026-08-01',
		type: 'Deposit',
		amount: 3500000,
		description: '월급',
		accountId: 'acc-checking',
		accountName: '새봄은행',
		currency: 'KRW',
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		tagNames: '수입',
	},
	{
		id: 'tag-3',
		date: '2026-07-29',
		type: 'Withdrawal',
		amount: 1100000,
		description: '월세',
		accountId: 'acc-checking',
		accountName: '새봄은행',
		currency: 'KRW',
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		tagNames: '공과금',
	},
	{
		id: 'tag-4',
		date: '2026-07-25',
		type: 'Purchase',
		amount: 125000,
		description: '업무용 서적',
		accountId: 'acc-credit',
		accountName: '리워드 카드',
		currency: 'KRW',
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		tagNames: '업무, 세금',
	},
	{
		id: 'tag-5',
		date: '2026-07-20',
		type: 'Purchase',
		amount: 220000,
		description: '소프트웨어 구독',
		accountId: 'acc-credit',
		accountName: '리워드 카드',
		currency: 'KRW',
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		tagNames: '업무, 세금',
	},
	{
		id: 'tag-6',
		date: '2026-07-18',
		type: 'Purchase',
		amount: 32000,
		description: '마트',
		accountId: 'acc-credit',
		accountName: '리워드 카드',
		currency: 'KRW',
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		tagNames: '식비',
	},
];
